import { render, staticRenderFns } from "./SubtitleText.vue?vue&type=template&id=e0ac8e48&"
import script from "./SubtitleText.vue?vue&type=script&lang=js&"
export * from "./SubtitleText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports